import React, {useState} from 'react';
import VerifyCard from './cards/VerifyCard';
import SaveTransaction from './cards/SaveTransaction';
import HistoriqueOperations from './HistoriqueOperations';
import './InstitutionDashboard.css'

function InstitutionDashboard() {
  const [carteValide, setCarteValide] = useState(false);

  const verifierCarte = (carteValide) => {
    setCarteValide(carteValide);
  };
  return (
    <div className="institution-dashboard">
      <div className="save-transaction-container">
        <VerifyCard verifierCarte={verifierCarte} />
        {carteValide && <SaveTransaction />}
      </div>
      {/* <div className="historique-operations-container">
        <HistoriqueOperations />
      </div> */}
    </div>

  )
}

export default InstitutionDashboard